<!-- -----------------------------------------------------------------------
<copyright file="dialog-box.component.html" company="LGT India">
     Author: vanaraj  
     Copyright (c) LGT India. All rights reserved.
</copyright>
----------------------------------------------------------------------- -->
<main class="main-div">
  <h2 mat-dialog-title class="user-h2">Edit User</h2>
  <mat-dialog-content>
    <mat-divider></mat-divider>
    <br />
    <div class="users-list">
      <div class="selected-main">
        <div class="selected-user-div">
          <div class="selected-user">
            <!-- Bind account_name from data object -->
            {{ data.account_name }}
            <div class="admin-check">
              <mat-checkbox
                class="mdc-checkbox html"
                [(ngModel)]="makeasAdmin"
                (change)="updateMakeAdmin($event)"
              >
              Is Admin
              </mat-checkbox>
              <mat-checkbox
                class="mdc-checkbox html"
                [(ngModel)]="loginAdmin"
                (change)="updateLoginAdmin($event)"
              >
              Login Access
              </mat-checkbox>
            </div>
          </div>
        </div>
        <div class="footer">
          <button
          mat-raised-button
            color="primary"
            style="
              width: 394px;
              height: 54px;
              padding: 18px, 0px, 18px, 0px;
              border-radius: 5.76px;
              border: 0.72px;
              color: #00498f;
              background: #ffff;
            "
            (click)="onCancelClick()"
          >
            Cancel
          </button>
          <button
            mat-raised-button
            color="primary"
            style="
              width: 394px;
              height: 54px;
              padding: 18px, 0px, 18px, 0px;
              border-radius: 5.76px;
              background: #00498f;
            "
            (click)="onEditUser()"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</main>
